import React, { Suspense } from 'react'
import { Routes, Route, Navigate, BrowserRouter, useLocation } from 'react-router-dom'
//import { ConnectedRouter } from 'react-router-redux'
import PrimaryMenuBar from './components/ui/PrimaryMenuBar'
import Footer from './components/ui/Footer'
import { useSelector } from 'react-redux';

import * as cloakAnalytics from './services/cloakAnalytics';

import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';

import CloakingPage from './pages/CloakingPage'
import UncloakingPage from './pages/UncloakingPage'
import ApprovalsPage from './pages/ApprovalsPage'
import RequestsPage from './pages/RequestsPage'
import SettingsPage from './pages/SettingsPage'
import UpgradePage from './pages/UpgradePage'
import QRCloakingPage from './pages/QRCloakingPage'
import JoinAccountPage from './pages/JoinAccountPage'

import LoginPage from './pages/LoginPage'
import SignUpPage from './pages/SignUpPage'
import NewLandingPageSignup from './pages/NewLandingPageSignup'
import NewLandingPageQR from './pages/NewLandingPageQR'
import NewLandingPageEntGwy from './pages/NewLandingPageEntGwy'
import UnsubscribePage from './pages/UnsubscribePage'
import VerifyPage from './pages/VerifyPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import EnterpriseLoginPage from './pages/EnterpriseLoginPage'


const theme = createTheme();
const PaymentPage = React.lazy(() => import('./pages/PaymentPage'));

// ** See notes on this `<App>` component at the bottom of this file **

const App = props => {

  // Initializes PostHog once on app mount and fires page_viewed on every
  // route change. Pre-login surface only — stopOnLogin() runs the moment a
  // token appears in redux (see AuthBoundary below).
  const LocationLogger = () => {
    const location = useLocation();
    React.useEffect(() => {
      cloakAnalytics.init();
    }, []);
    React.useEffect(() => {
      console.log('Current path:', location.pathname);
      cloakAnalytics.pageViewed(location.pathname, document.title);
    }, [location]);

    return null;
  };

  // Watches the redux auth token; the first time it becomes truthy we stop
  // PostHog so no further events fire from authenticated routes. Idempotent —
  // safe even if Redux replays the token transition.
  const AuthBoundary = () => {
    const token = useSelector(state => state.auth.token);
    React.useEffect(() => {
      if (token) cloakAnalytics.stopOnLogin();
    }, [token]);
    return null;
  };

  // Custom component to handle authorized routes
  const PrivateRoute = ({ element: Element, ...rest }) => {
    const token = useSelector(state => state.auth.token);
    //return token ? <Element {...rest} /> : null;
    return token ? <Element {...rest} /> : <Navigate to="/cloak/login" />;
  };


  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <div className='clk-primary-page'>
            <PrimaryMenuBar />
            <div className="clk-primary-layout-div">
              <LocationLogger />
              <AuthBoundary />
              <Routes>
                <Route path="/cloak/newsu" element={<NewLandingPageSignup />} />
                <Route exact path="/cloak/newqr" element={<NewLandingPageQR />} />
                <Route exact path="/cloak/newgwy" element={<NewLandingPageEntGwy />} />

                <Route exact path="/cloak/qr" element={<QRCloakingPage />} />
                <Route path="/cloak/join-account" element={<JoinAccountPage />} />

                <Route path="/cloak/login" element={<LoginPage />} />
                <Route exact path="/cloak/signup" element={<SignUpPage />} />
                <Route exact path="/cloak/exclude" element={<UnsubscribePage />} />
                <Route path="/cloak/forgot-password" element={<ForgotPasswordPage mode="1" />} />
                <Route path="/cloak/reset-password" element={<ForgotPasswordPage mode="2" />} />
                <Route path="/cloak/verify-email" element={<VerifyPage />} />
                <Route path="/cloak/enterprise-login" element={<EnterpriseLoginPage />} />

                {/* private routes, requiring authentication. have to match for public routes first */}
                <Route path="/cloak/upgrade" element={<PrivateRoute element={UpgradePage} />} />
                <Route path="/cloak/cloak" element={<PrivateRoute element={CloakingPage} />} />
                <Route path="/cloak/uncloak" element={<PrivateRoute element={UncloakingPage} />} />
                <Route path="/cloak/requests" element={<PrivateRoute element={RequestsPage} />} />
                <Route path="/cloak/approvals" element={<PrivateRoute element={ApprovalsPage} />} />
                <Route path="/cloak/settings" element={<PrivateRoute element={SettingsPage} />} />
                <Route path="/cloak/payment" element={
                  <Suspense fallback={null}>
                    <PrivateRoute element={PaymentPage} />
                  </Suspense>
                } />

                {/* <Route path="/cloak/qr" element={<PrivateRoute element={QRCloakingPage} />} />
                <Route path="/cloak/join-account" element={<PrivateRoute element={JoinAccountPage} />} /> */}

                {/* Add a default route or a 404 page */}
                <Route path="*" element={<Navigate to="/cloak/login" />} />

                {/* {
                  window.innerWidth < 500 ? (
                    //(typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1) ? (
                    //<Navigate to="/cloak/login" element={<UnauthorizedLayout />} />
                    <Navigate to="/cloak/qr" element={<UnauthorizedLayout />} />
                  ) : (
                    <Navigate to="/cloak/qr" element={<UnauthorizedLayout />} />
                  )
                } */}
              </Routes>
            </div>
            <Footer />
          </div>
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
